export function areSameAddress(a, b) {
  return a && b && a.toLowerCase() === b.toLowerCase()
}
